export default {
    computed: {
        intPage() {
            if (!this.urlPage) {
                return 0
            }
            return parseInt(this.urlPage)
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixin/intPage.js